import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { OverChargeSearchFilters } from '@/views/screens/Claims/types';

export type OverChargeClaimsExportRequestParams = Omit<OverChargeSearchFilters, 'byAge' | 'pageSize' | 'pageNo'> & {
  claimNo?: string | null;
  EndDate?: string;
  fbocKey?: string | null;
  StartDate?: string;
  StatusCodes?: string;
};

export type OverChargeClaimsExportResponseRow = Record<string, unknown>;

export interface OverChargeClaimsExportResponse {
  claimsData?: OverChargeClaimsExportResponseRow[];
}

export const getOverChargeClaimsExportAPI = (params: OverChargeClaimsExportRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.OVERCHARGE_CLAIM}/GetOCClaimDataForExport`,
  });
};

export const fetchOverChargeClaimsExport = async (
  params: OverChargeClaimsExportRequestParams,
): Promise<OverChargeClaimsExportResponse> => {
  const response: AxiosResponse<OverChargeClaimsExportResponse> = await getOverChargeClaimsExportAPI(params);
  return response.data;
};
